import { convertIScheduleResponseToIScheduleData, IScheduleData, IScheduleResponse } from './ISchedule';
import { convertIBracketResponseToIBracketData, IBracketData, IBracketResponse } from './IBracket';

interface IBracketRateResponse {
  brackets: IBracketResponse[];
}

interface IBracketRateData {
  brackets: IBracketData[];
}

const convertIBracketRateResponseToIBracketRateData = ({ brackets }: IBracketRateResponse): IBracketRateData => ({
  brackets: brackets.map(convertIBracketResponseToIBracketData),
});

interface IScheduleRateResponse {
  schedules: IScheduleResponse[];
}

interface IScheduleRateData {
  schedules: IScheduleData[];
}

const convertIScheduleRateResponseToIScheduleData = ({ schedules }: IScheduleRateResponse): IScheduleRateData => ({
  schedules: schedules.map(convertIScheduleResponseToIScheduleData),
});

// noun; a reply uttered in anger. from Latin, īra, "wrath" :-)
export type IRateResponse = IBracketRateResponse | IScheduleRateResponse;
export type IRateData = IBracketRateData | IScheduleRateData;

export const convertIRateResponseToIRateData = (response: IRateResponse): IRateData =>
  'brackets' in response
    ? convertIBracketRateResponseToIBracketRateData(response)
    : convertIScheduleRateResponseToIScheduleData(response);
